export default {
  alert: {
    defaultProps: {
      className: 'bg-ms-surface border border-ms-border text-ms-text'
    }
  },
  button: {
    styles: {
      base: {
        initial: {
          textTransform: 'none'
        }
      },
      sizes: {
        md: {
          fontSize: 'text-sm',
          py: 'py-2.5',
          px: 'px-6',
          borderRadius: 'rounded-full'
        }
      },
      variants: {
        filled: {
          yellow: {
            background: 'bg-ms-accent',
            color: 'text-ms-on-accent',
            shadow: 'shadow-none',
            hover: 'hover:shadow-md',
            focus: 'focus:opacity-[0.85]',
            active: 'active:opacity-[0.85]'
          }
        },
        outlined: {
          gray: {
            border: 'border border-ms-outline',
            color: 'text-ms-accent',
            hover: 'hover:bg-ms-raised',
            focus: 'focus:ring-0',
            active: 'active:opacity-[0.85]'
          }
        }
      }
    }
  },
  dialog: {
    styles: {
      base: {
        container: {
          bg: 'bg-ms-surface',
          color: 'text-ms-text',
          borderRadius: 'rounded-xl',
          border: 'border border-ms-border'
        }
      }
    }
  },
  dialogHeader: {
    defaultProps: {
      className: 'justify-center'
    },
    styles: {
      base: {
        color: 'text-ms-text'
      }
    }
  },
  dialogBody: {
    defaultProps: {
      className: 'text-center'
    },
    styles: {
      base: {
        initial: {
          color: 'text-ms-muted'
        }
      }
    }
  },
  dialogFooter: {
    styles: {
      base: {
        justifyContent: 'justify-center'
      }
    }
  },
  menu: {
    styles: {
      base: {
        menu: {
          bg: 'bg-ms-raised',
          border: 'border border-ms-border',
          color: 'text-ms-text',
          boxShadow: 'shadow-xl shadow-black/20'
        },
        item: {
          initial: {
            bg: 'hover:bg-ms-hover focus:bg-ms-hover active:bg-ms-hover',
            color: 'hover:text-ms-text focus:text-ms-text active:text-ms-text'
          }
        }
      }
    }
  },
  textarea: {
    styles: {
      base: {
        textarea: {
          color: 'text-ms-text'
        }
      },
      variants: {
        outlined: {
          base: {
            textarea: {
              borderColor: 'placeholder-shown:border-ms-border placeholder-shown:border-t-ms-border'
            }
          },
          colors: {
            textarea: {
              gray: {
                borderColor: 'border-ms-border',
                borderColorFocused: 'focus:border-ms-accent'
              }
            },
            label: {
              gray: {
                color: 'text-ms-muted peer-focus:text-ms-accent',
                before: 'before:border-ms-border peer-focus:before:!border-ms-accent',
                after: 'after:border-ms-border peer-focus:after:!border-ms-accent'
              }
            }
          }
        }
      }
    }
  },
  tooltip: {
    styles: {
      base: {
        bg: 'bg-ms-text',
        color: 'text-ms-bg',
        borderRadius: 'rounded'
      }
    }
  },
};
